
// navbar

const header = document.querySelector(".navpage-header");
const toggleClass = "is-sticky";

window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll >50) {
        header.classList.add(toggleClass);
    } else {
        header.classList.remove(toggleClass);
    }
});
// end



 
// ----------scrolling-image-js--left-right-----

  gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const tl = gsap.timeline();
  tl.to(".loader", {
    delay: 2,
    opacity: 0,
    duration: 1,
    ease: Power3.easeOut
  });

  let container = document.querySelector(".reveal-inview");
  let image = container.querySelector("img");

  tl.set(container, { autoAlpha: 1 });
  tl.from(container, 1.5, {
    xPercent: -100,
    ease: Power2.out
  });
  tl.from(image, 1.5, {
    xPercent: 100,
    scale: 1.3,
    delay: -1.5,
    ease: Power2.out
  });

  let revealContainers = document.querySelectorAll(".reveal-scroll");

  revealContainers.forEach((container) => {
    let image = container.querySelector("img");
    let tl = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: container,
        toggleActions: "restart none none reset"
      }
    });

    tl.set(container, { autoAlpha: 1 });
    tl.from(container, 1.5, {
      xPercent: -100,
      ease: Power2.out
    });
    tl.from(image, 1.5, {
      xPercent: 100,
      scale: 1.3,
      delay: -1.5,
      ease: Power2.out
    });
  });
});


// ----------end-------


// ---------text-reveal-js-------

gsap.registerPlugin(ScrollTrigger)




let trigger = gsap.utils.toArray('.slide-right');

trigger.forEach((element) => {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: element,
            toggleActions : "restart resume"
           
        }
    });

    tl.from(element, {
            duration: 4,
            ease: "power4.out",
            x: "450px",
           
         });


    tl.to(".slide-left", {
        duration: 1,
        ease: "power1.out",
        x: "-450px",
      
    });
    
})






// -----end------------


$(document).ready(function(){
    var $owl = $("#testi-slid1");

    // Destroy previous instance if already initialized
    if ($owl.hasClass('owl-loaded')) {
        $owl.trigger('destroy.owl.carousel');
        $owl.find('.owl-stage-outer').children().unwrap();
    }

    // Initialize Owl Carousel
    $owl.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        smartSpeed: 2000, // smooth transition
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        mouseDrag: true,
        responsive: {
            0: { items: 1, nav: true },
            600: { items: 1, nav: false },
            1000: { items: 1, nav: false }
        },
        navText: [
            "<span><i class='fa-solid fa-chevron-left'></i></span>",
            "<span><i class='fa-solid fa-chevron-right'></i></span>"
        ]
    });

    // Restart autoplay when mouse leaves
    $owl.on('mouseleave', function() {
        $owl.trigger('play.owl.autoplay', [5000]);
    });

    // 👇 Force autoplay restart when the tab becomes visible again
    document.addEventListener("visibilitychange", function() {
        if (!document.hidden) {
            $owl.trigger('play.owl.autoplay', [5000]);
        }
    });
});




// --------image-vertical-scroll----------

gsap.registerPlugin(ScrollTrigger);

let revealContainers = document.querySelectorAll(".revealvertical");

revealContainers.forEach((container) => {
  let image = container.querySelector("img");

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      toggleActions: "restart none none reset"
    }
  });

  tl.set(container, { autoAlpha: 1 });

  // REVEAL FROM BOTTOM TO TOP
  tl.from(container, 1.5, {
    yPercent: 100,
    ease: Power2.out
  });

  tl.from(image, 1.5, {
    yPercent: -100,
    scale: 1.3,
    delay: -1.5,
    ease: Power2.out
  });
});




// -----------end-------------













